import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import axios from "axios";

export default function TeacherAttendancePieChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getTodayDate = () => {
    const today = new Date();
    return today.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  };

  // Fetch attendance summary based on session
  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const session = localStorage.getItem("currentSessionId"); // get session from localStorage
        if (!session) {
          console.error("Session not found in localStorage");
          setData({ present: 0, absent: 0 });
          return;
        }

        const todayISO = new Date().toISOString().split("T")[0]; // get today's date
        const res = await axios.get(
          ` ${process.env.REACT_APP_API_BASE_URL}/api/teacherAttendances/summary/today?session=${session}&date=${todayISO}`
        );

        // Handle empty or null response
        setData({
          present: res.data?.present || 0,
          absent: res.data?.absent || 0,
        });
      } catch (err) {
        console.error("Error fetching teacher attendance:", err);
        setData({ present: 0, absent: 0 });
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  // Initialize or update chart
  useEffect(() => {
    if (!data) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    chartInstance.current.setOption({
      title: {
        text: `Teacher Attendance (${getTodayDate(data.date)})`,
        left: "center",
        textStyle: { fontSize: 14, fontWeight: "bold" },
      },
      tooltip: { trigger: "item" },
      series: [
        {
          name: "Attendance",
          type: "pie",
          radius: "45%",
          data: [
            { value: data.present, name: "Present" },
            { value: data.absent, name: "Absent" },
          ],
          color: ["#81C789", "#FFD54F"],
          emphasis: { itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.4)" } },
        },
      ],
    });

    const handleResize = () => chartInstance.current?.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chartInstance.current?.dispose();
      chartInstance.current = null;
    };
  }, [data]);

  return (
    <div style={{ position: "relative" }}>
      {loading && <p style={{ textAlign: "center" }}>Loading Teacher Attendance...</p>}
      <div
        ref={chartRef}
        style={{
          width: "100%",
          height: "250px",
          background: "#fff",
          borderRadius: "10px",
          padding: "10px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        }}
      />
    </div>
  );
}
